import gql from 'graphql-tag'

export const howToData = gql`
  query howToData($locale: SiteLocale) {
    comeFunziona(locale: $locale) {
        seo {
          description
          title
          twitterCard
          image {
            url
          }
        }
        intro
        title
        imageFlowDesk {
          url
        }
        imageFlowMobile {
          url
        }
        introFasi
        textFasi
        
    }
        allFasis(locale: $locale) {
            position
            titolo
            slug
            abstract
            coverDesk {
                responsiveImage {
                  src
                  srcSet
                }
              }
            coverMobile {
                responsiveImage {
                  src
                  srcSet
                }
              }  
          }
        
}
`

export const allFasis = gql`
  query allFasis($locale: SiteLocale) {
    allFasis(locale: $locale) {
            position
            titolo
            slug
            abstract
            coverDesk {
                responsiveImage {
                  src
                  srcSet
                }
              }
            coverMobile {
                responsiveImage {
                  src
                  srcSet
                }
              }  
          }
}
`
